import { isNullOrEmptyOrUndefined } from "../components/Helpers/Util";
import { GET_IMZACI_SECIM_KURAL } from "../constants/requestUrls";
import { getRequest } from "../request";

const getImzaciSecimKural = (altSurecTipiId,parentBasvuruId) => {
    let urlParam = "?parentBasvuruId=" + parentBasvuruId;
    if(!isNullOrEmptyOrUndefined(altSurecTipiId)){
        urlParam += "&altSurecTipiId=" + altSurecTipiId ;
    }
    return getRequest({ url: GET_IMZACI_SECIM_KURAL + urlParam });
}

export default getImzaciSecimKural;